import { render } from "./readRma.vue?vue&type=template&id=1ed45cb6&scoped=true"
import script from "./readRma.vue?vue&type=script&lang=js"
export * from "./readRma.vue?vue&type=script&lang=js"

import "./readRma.vue?vue&type=style&index=0&id=1ed45cb6&lang=scss&scoped=true"

import exportComponent from "/root/workspace/apm-rma-frontend_iTfK/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed45cb6"]])

export default __exports__